<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="voucher-code">
    <div
      class="voucher-code__code"
      :class="{ hover: hover || copied == code }"
      @click="copy(code)"
      @mouseover="hover = true"
      @mouseleave="hover = false"
    >
      {{ displayCode }}
      <span v-if="copied === code" class="hover-text">{{ "Copied" | t }}</span>
      <span v-else-if="hover" class="hover-text">{{
        "Click to copy" | t
      }}</span>
      <i class="icon fal fa-copy"></i>
    </div>
    <span
      v-if="pin"
      class="voucher-pin"
      :class="{ hover: hoverpin || copied == pin }"
      @mouseover="hoverpin = true"
      @mouseleave="hoverpin = false"
      @click="copy(pin)"
    >
      PIN: {{ pin }}
      <span v-if="copied === pin" class="hover-text">{{ "Copied" | t }}</span>
      <span v-else-if="hoverpin" class="hover-text">{{
        "Click to copy" | t
      }}</span>
      <i
        class="icon fal fa-copy"
        aria-hidden="true"
        style="position: absolute; right: 16px; -webkit-transform: translateY(25%); transform: translateY(25%);"
      ></i>
    </span>
  </div>
</template>

<script>
export default {
  name: "VoucherCode",
  props: {
    code: {
      type: String,
      required: true,
    },
    pin: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      hover: false,
      hoverpin: false,
      copied: false,
      displayCode: null,
    };
  },
  mounted() {
    this.displayCode = this.code;
  },
  methods: {
    copy(code) {
      this.copyAction(code);
      this.copied = code;
      setTimeout(() => {
        this.copied = false;
      }, 1000);
    },
    copyAction(code) {
      const el = document.createElement("textarea");
      el.value = code;
      el.setAttribute("readonly", "");
      el.style.position = "absolute";
      el.style.left = "-9999px";
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
    },
  },
};
</script>
